<telxl-panel
    bodyClass="card-body-sm"
    cardClass="mb-2"
    [hover]="true"
    [isExpanded]="isExpanded()"
>
    <ng-template #cardHeader>
        <div class="d-flex flex-column w-100">
            <div class="d-flex align-items-center justify-content-between pb-1">
                <div class="font-sm weight-medium">
                    @if (activity().isMonitoringWorkItem) {
                        Monitored Call
                    } @else if (activity().isOutbound) {
                        {{ activity().channelName }}
                    } @else {
                        {{ activity().queue?.name ?? 'Unknown Queue' }}
                    }
                </div>
                <div class="font-sm">
                    {{ activity().date | date: 'dd/MM/y HH:mm ' }}
                </div>
            </div>
            <div class="d-flex pb-1">
                @if (variation() === 'customer') {
                    <telxl-tag [text]="agentName" />
                } @else if (variation() === 'agent') {
                    <telxl-tag [text]="customerName" />
                }
            </div>
            <div class="d-flex pb-1 justify-content-between">
                <div class="d-flex flex-row">
                    <telxl-media-tag
                        size="sm"
                        class="pe-1"
                        [media]="
                            channelTypeToQueueMediaType(activity().channelType)
                        "
                        fill="outline"
                    />
                    <telxl-activity-result-tag
                        class="pe-1"
                        [result]="activity().result"
                        [outline]="true"
                    />
                    <telxl-tag [text]="duration" [outline]="true" />
                </div>
                <div>
                    <div
                        tabindex="1"
                        class="primary-hover"
                        (click)="toggleExpandedView()"
                        (keypress)="toggleExpandedView()"
                    >
                        <i
                            class="fa-solid fa-sm"
                            [ngClass]="{
                                'fa-chevron-down': !isExpanded(),
                                'fa-chevron-up': isExpanded(),
                            }"
                        ></i>
                    </div>
                </div>
            </div>
            @if (isExpanded()) {
                <div class="d-flex flex-row">
                    <telxl-tag [text]="completioncode" [outline]="true" />
                </div>
            }
        </div>
    </ng-template>

    <ng-template #cardBody>
        <telxl-shared-activity-history-conversation [activity]="activity()" />
    </ng-template>
</telxl-panel>
